export enum EmspTxStatus {
  REMOTE_STARTED = 'REMOTE_STARTED',
  REMOTE_START_NO_SHOW = 'REMOTE_START_NO_SHOW',
  REMOTE_START_EXPIRED = 'REMOTE_START_EXPIRED',
  IN_PROGRESS = 'IN_PROGRESS',
  FINISHED = 'FINISHED',
  INVALID = 'INVALID'
}
